module.exports = __webpack_public_path__ + "img/12.4ea82e47.png";